<template>
  <div>
    <v-tabs
      class="v-tabs--pill primary white--text"
      hide-slider
      active-class="white primary--text"
      v-model="activeTab"
      show-arrows
      dark
      background-color="transparent"
      centered
      touchless
      icons-and-text
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.name"
        :to="{ name: tab.name, params: { id: $route.params['id'] } }"
      >
        {{ tab.text }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  computed: {},
  data() {
    return {
      activeTab: "",
      tabs: [
        {
          name: "UserProfile/BasicInformation",
          text: this.$t("userProfile.tabs.basicInfo")
        },
        {
          name: "UserProfile/Tasks",
          text: this.$t("userProfile.tabs.tasks")
        }
      ]
    };
  }
};
</script>

<style></style>
